module.exports = __webpack_public_path__ + "static/media/special.bc071481.png";